import { createContext, useContext, useEffect, useState } from "react";
import Toast from "./Toast";

const ToastContext = createContext();

export default function ToastWrapper({ children }) {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (!toast) return;

    const duration = typeof toast.durationMs === "number" ? toast.durationMs : 5000;

    if (duration === Infinity || duration === null) return;

    const timeoutId = window.setTimeout(() => setToast(null), duration);
    return () => window.clearTimeout(timeoutId);
  }, [toast]);

  const dismissToast = () => setToast(null);

  const showToast = (content, options = {}) => {
    if (content === null || content === undefined) {
      setToast(null);
      return;
    }

    const {
      dismissible = false,
      durationMs = 5000,
      dismissButtonVariant = "inverted",
      ...rest
    } = options;

    setToast({
      content,
      dismissible,
      durationMs,
      dismissButtonVariant,
      ...rest,
    });
  };

  return (
    <ToastContext.Provider value={{ setToast: showToast, dismissToast }}>
      {children}
      {toast && (
        <Toast
          dismissible={toast.dismissible}
          onDismiss={dismissToast}
          dismissButtonVariant={toast.dismissButtonVariant || "primary"}
          layer={toast.layer || "default"}
        >
          {toast.content}
        </Toast>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
